<template lang="pug">
  .row
    .col-lg-6(v-if="order.shipping_address")
      h4.order-details__title(v-if="order.shipping_address") {{ trans('labels.frontend.account.profile.shipping-address') }}
      p.mb-0 {{ order.shipping_address.first_name + ' ' + order.shipping_address.last_name }}
      address
        | {{ order.shipping_address.tel }}
        br
        | {{ order.shipping_address.address }}
        span(v-if="order.shipping_address.district_txt")  {{ order.shipping_address.district_txt }}
        span(v-if="order.shipping_address.amphure")  {{ order.shipping_address.amphure.name_th }}
        span(v-if="order.shipping_address.province")  {{ order.shipping_address.province.name_th }}
        span(v-if="order.shipping_address.district")  {{ order.shipping_address.district.zip_code }}
    .col-lg-6(v-if="order.billing_address")
      h4.order-details__title {{ trans('labels.frontend.account.profile.billing-address') }}
      p.mb-0 {{ order.billing_address.company_name }}
      p.mb-0 {{ trans('labels.frontend.user.profile.tax-number') }} {{ order.billing_address.tax_number }}
      address
        span(v-if="!order.billing_address.branch_number") {{ trans('labels.frontend.user.profile.branch') }} {{ trans('labels.frontend.user.profile.headquarter') }}
        span(v-if="order.billing_address.branch_number") {{ trans('labels.frontend.user.profile.branch-number') }} {{ order.billing_address.branch_number }}
        br
        | {{ order.billing_address.address }}
        span(v-if="order.billing_address.district_txt")  {{ order.billing_address.district_txt }}
        span(v-if="order.billing_address.amphure")  {{ order.billing_address.amphure.name_th }}
        span(v-if="order.billing_address.province")  {{ order.billing_address.province.name_th }}
        span(v-if="order.billing_address.district")  {{ order.billing_address.district.zip_code }}
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
};
</script>
